'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common = require('./common.cjs');
var unwrapOption = require('./unwrapOption.cjs');
var unwrapOptionRecursively = require('./unwrapOptionRecursively.cjs');



exports.isNone = common.isNone;
exports.isOption = common.isOption;
exports.isSome = common.isSome;
exports.none = common.none;
exports.some = common.some;
exports.unwrapOption = unwrapOption.unwrapOption;
exports.unwrapSome = unwrapOption.unwrapSome;
exports.unwrapSomeOrElse = unwrapOption.unwrapSomeOrElse;
exports.wrapNullable = unwrapOption.wrapNullable;
exports.wrapNullish = unwrapOption.wrapNullish;
exports.unwrapOptionRecursively = unwrapOptionRecursively.unwrapOptionRecursively;
//# sourceMappingURL=index.cjs.map
